var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ dashboard__data: !_vm.report }},[(_vm.report)?[_c('div',{staticClass:"reports__row"},[_c('span',[_vm._v("Участники программы:")]),_c('span',[_vm._v(_vm._s(_vm.countUsers.toLocaleString()))])])]:[_c('app-dashboard-num',{attrs:{"number":_vm.countUsers}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }